import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { ApplicationSettingsService } from '@rocksoft/settings-sdk';
import { map, mergeMap } from 'rxjs/operators';
import { AppSettingsApiActions } from '../app-settings/app-settings.actions';
import { safeMap } from '../effects.helpers';
import {
  ApplicationsConfiguredSettingsApiActions,
  ApplicationsConfiguredSettingsResolverActions,
} from './applications-configured-settings.actions';

@Injectable()
export class ApplicationsConfiguredSettingsEffects {
  private readonly actions$ = inject(Actions);
  private readonly applicationSettingsService = inject(ApplicationSettingsService);

  applicationsConfiguredSettingsLoadedEffect$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ApplicationsConfiguredSettingsResolverActions.applicationsConfiguredSettingsRequested),
      mergeMap(({ categoryId }) =>
        safeMap(
          this.applicationSettingsService.getApplicationsWithSettingsForCategory({ categoryId }),
          (settings) =>
            ApplicationsConfiguredSettingsApiActions.applicationsConfiguredSettingsLoaded({
              categoryId,
              settings: settings.map((setting) => ({
                categoryId,
                bundleIdentifier: setting.bundleIdentifier,
                displayName: setting.displayName ?? null,
                adamIdStr: setting.adamIdStr ?? null,
              })),
            }),
          (error) => ApplicationsConfiguredSettingsApiActions.applicationsConfiguredSettingsLoadedError({ error })
        )
      )
    );
  });

  appSettingsLinkedEffect$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(AppSettingsApiActions.appSettingsLinkedToCategory),
      map(({ categoryId }) =>
        ApplicationsConfiguredSettingsResolverActions.applicationsConfiguredSettingsRequested({ categoryId })
      )
    );
  });
}
